import ru from 'vee-validate/dist/locale/ru.json';

export default {
  ...ru.messages,
  required: 'Обязательное поле',
  numeric: 'Только числа',
  email: 'Ожидается электронная почта',
  type: `Поддерживаемые типы файлов: {value}`,
  size: `Файл не должен превышать {value}Мб`,
  sumSize: `Общий размер файлов не должен превышать {value}Мб`,
  notLaterToday: 'Не позже текущей даты',
};
